<vs-card class="overflow-hidden">
  <vs-card-header
    [config]="{
      title: 'Parties',
      subtitle: 'Insurers, agents, administrators and other parties that rating-matrix fees can be attributed to. Sellers are your distributors. Shared across all policies.'
    }"
  >
    <vs-badge slot="after-title">{{ parties.length }} {{ parties.length === 1 ? 'party' : 'parties' }}</vs-badge>

    <div *ngIf="canEdit$ | async" slot="end" class="flex gap-2">
      <button vs-button theme="primary" (click)="create()">
        <vs-icon name="plus"></vs-icon>
        Add Party
      </button>
    </div>
  </vs-card-header>

  <vs-card-content class="!px-0 !pb-0 overflow-hidden !rounded-b-xl">
    <div class="flex justify-end gap-3 px-4 py-3 border-b border-gray-200">
      <vs-input-container class="w-full max-w-xs">
        <vs-icon name="search-lg" slot="start"></vs-icon>
        <input type="text" placeholder="Search by name" [(ngModel)]="search" (keyup.enter)="load()" (blur)="load()" />
      </vs-input-container>
      <vs-select vsInput class="w-48" [value]="roleFilter" (valueChanges)="onRoleFilterChange($event)">
        <li vs-select-option value="all">All roles</li>
        <li *ngFor="let option of roleOptions" vs-select-option [value]="option.role">{{ option.label }}</li>
      </vs-select>
    </div>

    <div *ngIf="loading" class="px-4 py-6 text-sm text-gray-500">Loading...</div>

    <vs-table *ngIf="!loading && parties.length" [data]="parties" [columns]="(columns$ | async) ?? []"></vs-table>

    <div *ngIf="!loading && !parties.length" class="px-4 py-6 text-sm text-gray-500">
      No parties yet. Add insurers, agents and other recipients here, then assign them to Fee Types on the Dimensions
      tab or to individual cells in the rating matrix.
    </div>
  </vs-card-content>
</vs-card>

<ws-party-dialog #partyDialog (closed)="onDialogClosed($event)"></ws-party-dialog>
<ws-delete-party-dialog #deletePartyDialog (closed)="onDialogClosed($event)"></ws-delete-party-dialog>
